import {StyleSheet} from 'react-native';

import {responsive} from '../../lib/utils';
import {addOpacityToColorHex} from '../../lib/utils/colors';
import {colors} from '../../styles';

export const authStyles = StyleSheet.create({
  innerContainer: {
    flex: 1,
    paddingHorizontal: 24,
    paddingBottom: 12,
  },
  formContainer: {
    alignItems: 'center',
    flex: 1,
  },
  bodyContainer: {
    flex: 1,
    paddingTop: responsive(36),
    width: '100%',
    gap: responsive(16),
  },
  socialButton: {
    width: responsive(64),
    height: responsive(64),
  },
  optInField: {
    height: 40,
  },
  checkbox: {
    alignItems: 'center',
    borderWidth: 1,
    borderColor: addOpacityToColorHex(colors.white, 0.1),
    borderRadius: 4,
    padding: 10,
  },
  skipText: {
    color: colors.disabledTextGray,
    textTransform: 'uppercase',
  },
});
